import { useEffect } from 'react';

/**
 * Run `onClose` when Escape is pressed, but only while `enabled` is true.
 * Use this on inline modal patterns (`<div className="fixed inset-0...">`)
 * to add Escape-to-close behavior without rewriting the modal as a
 * dedicated component.
 */
export function useEscapeKey(enabled: boolean, onClose: () => void): void {
  useEffect(() => {
    if (!enabled) return;
    const handler = (event: KeyboardEvent) => {
      if (event.key === 'Escape') onClose();
    };
    document.addEventListener('keydown', handler);
    return () => document.removeEventListener('keydown', handler);
  }, [enabled, onClose]);
}
